import React, { Component } from "react";
import { connect } from "react-redux";
import _ , {debounce}from "lodash";
import cx from 'classnames';
import {
  WithStyles,
  createStyles,
  Typography,
  Button,
  Modal,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Paper,
  Link,
  TableHead,
  Table,
  TableBody,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  CircularProgress,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";

import {
  MyPATCollapse,
  MyPATLink,
  dateService,
  MyPATDialog
} from "../../common";
import { BorderAll } from "@material-ui/icons";
import { timingSafeEqual } from "crypto";
import classNames from "classnames";
import { bindActionCreators } from "redux";
import { showMsg } from "../../course/actions/loaderAlert";
import contentActions from "../actions/contentActions";
import PerfectScrollbar from 'react-perfect-scrollbar';
import { toggleLicenseExpiredDialog, setLoggedInUser } from "../../login/actions/userActions";
import {getCoupledTestList} from '../services/benchmarkService';
import contentService from '../services/contentService';
import { getPropertyValue } from "../../../utils";
const styles = (theme: Theme) =>
  createStyles({
    benchmarkAddBtn: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "19px",
      height: "44px",
      color: "#fff",
      backgroundColor: "#1D7DEA",
      boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.224892)",
      padding: "7px 31px",
      letterSpacing: "0.5px",
      "&:hover": {
        backgroundColor: "#1D7DEA"
      }
    },
    benchmarkButton: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "22px",
      Border: "solid 1px #1D7DEA",
      width: "100%",
      height: "44px"
    },
    blue: {
      border: "solid 1px #1D7DEA",
      boxSizing: "border-box",
      color: "#1D7DEA"
    },
    imgCenter: {
      textAlign: "center",
      margin: "55px 0 0 0"
    },
    headingtxt: {
      fontSize: "16px",
      color: "#333",
      lineHeight: "24px",
      margin: "14px 0 38px 0"
    },
    tableStr: {
      backgroundColor: "#F7F7F7",
      padding: "20px",
      width: "100%",
      borderRadius: "4px",
      margin: "20px 0 20px 0",
      "& Table": {
        "& thead": {
          "& td": {
            fontSize: "12px",
            fontWeight: 600,
            lineHeight: "16px",
            color: "#333",
            padding: "10px 0"
          }
        },
        "& tbody": {
          maxHeight: "200px",
          overflow: "auto",
          "& td": {
            fontSize: "10px",
            fontWeight: 600,
            lineHeight: "16px",
            color: "#666",
            padding: "10px 5px"
          }
        }
      }
    },
    tableHeading: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "19px",
      color: "#333",
      borderBottom: "0.5px solid #999999",
      padding: "0 0 8px 0"
    },
    benchmarkTable: {
      '&>:first-child' :{
        '&>:nth-child(3)':{
          opacity: 0,
        }
      },
      backgroundColor: "#fff",
      border: "1px solid #DCDCDC",
      borderRadius: "4px",
      padding: "30px 0px 22px 20px",
      margin: "0 0 15px 0",
      width: "610px",
      height: '370px',
      "& table": {
        "& thead": {
          marginBottom: "14px",
          "& td": {
            fontWeight: 600,
            fontSize: "16px",
            lineHeight: "18px",
          }
        },
        "& tbody": {
          "& td": {
            width: "32%",
            fontSize: "14px",  
          },
          "& tr :nth-child(3)": {
              paddingRight: '12px',
          },
        }
      },       
    },
    truncateTxt:{
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      display: 'inline-block',
      width: '180px!important',
      marginTop: '12px',
      padding:'18px 0',
    },
    truncateTxt1:{
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      width: '97px!important',
    },
    txtRight: {
      textAlign: "right"
    },
    graceTextField: {
      // width: "120px",
      margin: "0 0",
      "& input": {
        padding: "10px",
      },
      "& input[type=number]::-webkit-inner-spin-button, & input[type='number'].mod::-moz-inner-spin-button, & input[type=number]::-webkit-outer-spin-button, & input[type='number'].mod::-moz-outer-spin-button": {
        opacity: 0
      },
      "& input[type=number]":{
          '-moz-appearance': 'textfield',
          'appearance': 'none',          
      },
    },
    posRel: {
      position: "relative"
    },
    errorTxt: {
      color: "#F21D1D",
      fontSize: "12px",
      lineHeight: "16px",
      position: "absolute",
      bottom: "0px",
      width: "100%",
      left: "5px"
    },
    headingCenterTitle: {
      fontSize: "28px",
      fontWeight: 600,
      lineHeight: "32px"
    },
    disabled: {
      opacity: 0.5
    },
    // Overlay card
    overlayCard:{
    textAlign: 'center',
    height: '100%',
    position: 'absolute',
    left: '0',
    right: '0',
    top: '45px',
      '&::before':{
        content: '" "',
        background: 'rgba(255, 255, 255, 0.9)',
        borderRadius: '4px',
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: '0',
        zIndex: 1,
      }
    },
    overlayContent:{
      zIndex: 2,
      padding: '0 25px'
    },
    overlayTxt: {
      fontSize: '14px',
      lineHeight: '16px',
      color: '#f21d1d',
      marginTop: '13px',
    },  
    publishedBenchmark:{        
      '& thead':{
          display:'table',
          tableLayout:'fixed',
          width: '100%',
      },
        '& tbody':{
          display:'block',
          height:'150px',
          overflow:'auto',
          '& tr': {
            display:'table',
            width:'100%',
            tableLayout:'fixed',
          },
        },
    },
    
    benchmarkingParentCont: {
      paddingBottom: "20px",
    },
    testIds: {
      display: "flex",
      flexDirection: "row",
      paddingTop: "20px",
    },
    testInputCont: {
      flexBasis: "100%",
    },
    testInputTitle: {
      fontWeight: 600,
      paddingBottom: "10px",
    },
    testInput: {
      width: "250px",
      height: "40px",
      paddingLeft: "10px",
      border: "1px solid #DFDFDF",
    },
    discardDialog: {
      position: "absolute",
      width: "100%",
      left: "0",
      bottom: "0",
      height: "120px",
      zIndex: 2,
      background: "white",
      pointerEvents: "all",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-around",
      alignItems: "center",
    },
    discardDescriptionTest: {
      width: "330px",
    },
    discardAction: {
      display: "flex",
      justifyContent: "center",
      alignItems: "end",
      gap: "5px",
    },

    suggestionBox: {
      position: "absolute",
      background: "white",
      zIndex: 10,
      width: "250px",
      marginTop: "5px",
      border: "1px solid #DFDFDF",
      borderRadius: "4px",
      maxHeight: "192px",
    },
    suggestionItems: {
      display: "flex",
      flexDirection: "column",
      paddingBottom: "16px",
    },
    suggestionItem: {
      paddingTop: "8px",
      paddingBottom: "8px",
      fontSize: "14px",
      fontWeight: 400,
      "&:hover": {
        cursor: "pointer",
        color: "#666666",
      },
    },
    suggestionScrollbar: {
      maxHeight: "192px",
      paddingLeft: "10px",
      paddingTop: "17px",
      overscrollBehavior: "contain",
    },
    benchmarkingType: {
      display: "flex",
      alignItems: "center",
    },
    benchmarkingHeading: {
      color: "#333333",
      marginRight: "30px",
    },
    circularProgress: {
      position: "absolute",
      right: "20px",
      top: "8px",
    },
    coupledTestInput: {
      position: "relative",
    },
    dialogMain: {
      "& .perfectScrollBar": {
        paddingBottom: "15px",
      },
    },
    discardContentOpacity: {
      "& .perfectScrollBar": {
        paddingBottom: "15px",
        pointerEvents: "none",
      },
      "&::before": {
        background: "#000",
        opacity: 0.5,
        position: "absolute",
        left: 0,
        height: "100%",
        width: "100%",
        zIndex: 1,
        pointerEvents: "none",
        content: "''",
      },
    },
    allTestDetails: {
      "& span": {
        color: "#666666",
      },
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "20px",
      marginLeft: '-20px',
      fontSize: "14px",
      color: "#333333",
    },
    wrapper: {
      position: "relative",
    },
    reduceTableOpacity: {
      opacity: 0.5,
    },
    rowAlign: {
      flexDirection: "column",
      "& p": {
        margin: "1px",
      },
    },
    addBenchMarkStrip: {
      width: "100%",
      background: "#FFF9EB",
      padding: "10px",
      fontSize: "14px",
      fontWeight: 500,
      color: '#333333',
      position: "absolute",
      top: 0,
      left: 0,
      textAlign: "center",
    },
    marginTopStyle: {
      marginTop: 30,
    }
  });
  

//@ts-ignore
interface BenchmarkProps extends WithStyles<typeof styles> {
  classes: any;
  benchMarkInfo: any;
  onAdd: Function;
  onUpdate: Function;
  goalLevels: any;
  content: any;
  updateBenchMarkResponse: any,
  onUpdateComplete: Function,
  onClose: Function,
  fetchBenchMarkInfo: Function,
  isOpen: boolean
  from?: string,
  isPostExpiryDays: any,
  showLicenseExpiredDialog: any,
  toggleLicenseExpiredDialog: any,
  setLoggedInUser: any,
  addBenchmarkFromTest: boolean;
}

interface BenchmarkStates {
  // isOpenBenchmarkDialog: boolean;
  goalLevel: any;
  isError: boolean;
  updatedType: any;
  isLoaded: boolean;
  individualMaxMark: number;
  individualMinMark: number;
  coupledMaxMark: number;
  coupledMinMark: number;
  benchmarkingType: string;
  testSearchLoader: boolean;
  showSuggestionBox: boolean;
  coupledInputValue: string;
  isCoupledInputFocused: boolean;
  coupledTestContent: any;
  coupledTestContentId: string;
  coupledTestId: string,
  coupledTestDisplayName: string;
  suggestionBoxData: Array<any>;
  isCoupledTestAdded: boolean;
  coupledGoalLevel: any;
  individualGoalLevel: any;
  isDiscardDialogOpen: boolean;
  disableIndividualCheckbox: boolean;
  originalGoalLevel: any;
}

class Benchmark extends Component<BenchmarkProps, BenchmarkStates> {
  public benchmarkTypes = {
    INDIVIDUAL: 'Individual',
    COUPLED: 'Coupled',
  };
  public minSearchCharactersLength = 3;
  public maxTestCharacterLength = 60;
  constructor(props: BenchmarkProps) {
    super(props);
    this.handleBenchmark = this.handleBenchmark.bind(this);
    this.onAddBenchmark = this.onAddBenchmark.bind(this);
    this.renderBenchMarkInfo = this.renderBenchMarkInfo.bind(this);
    this.renderGoalLevels = this.renderGoalLevels.bind(this);
    this.handleUpdation = this.handleUpdation.bind(this);

    let self = this;
    self.state = {
      // isOpenBenchmarkDialog: false,
      isError: false,
      goalLevel: [],
      updatedType: "",
      individualMaxMark: 0,
      individualMinMark: 0,
      coupledMaxMark: 0,
      coupledMinMark: 0,
      isLoaded: false,
      benchmarkingType: this.benchmarkTypes.INDIVIDUAL,
      testSearchLoader: false,
      showSuggestionBox: false,
      coupledInputValue: '',
      suggestionBoxData: [],
      isCoupledInputFocused: false,
      coupledTestContent: {},
      coupledTestContentId: '',
      coupledTestId: '',
      coupledTestDisplayName: '',
      isCoupledTestAdded: false,
      coupledGoalLevel: [],
      individualGoalLevel: [],
      isDiscardDialogOpen: false,
      disableIndividualCheckbox: false,
      originalGoalLevel: [],
    };
  }

  componentDidMount(){
    this.props.setLoggedInUser();
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    // if(nextProps.updatBenchMarkResponse != prevState.updateBenchmarkResponse) {
    //   return {

    //   }
    // }
    let list: any = []
    let maxMarks = 0
    let minMarks = 0
   
    if(nextProps.goalLevels.goalLevels && prevState.goalLevel && 
      prevState.goalLevel !== nextProps.goalLevels.goalLevels) {
        if(prevState.goalLevel.length != nextProps.goalLevels.goalLevels.length) {
      let content, data, sections;
      let content1 = _.get(nextProps, 'content')
      let content2 = _.get(nextProps, 'content.content')
      let data1 = _.get(nextProps, 'content.data')
      let data2 = _.get(nextProps, 'content.content.data')
      let sections1 = _.get(nextProps, 'content.data.sections')
      let sections2 = _.get(nextProps, 'content.content.data.sections')
      content = content1 || content2
      data = data1 || data2
      sections = sections1 || sections2
      // if(nextProps.content && 
      //   nextProps.content.content &&
      //   (nextProps.content.data ||
      //   nextProps.content.content.data) && 
      //   (nextProps.content.data.sections.length || nextProps.content.content.data.sections.length)) {
          if(content && data && sections.length) {
          sections.map((section: any) => {
            section.subSection.map((item: any) => {
              let questionCountMultiplier = item.mandatoryQuestionCount || item.noOfQuestions || 0;
              minMarks = minMarks + (item.negativeMarks * questionCountMultiplier);
              maxMarks = maxMarks + (item.positiveMarks * questionCountMultiplier);
            })
          })
        }
        
      list = nextProps.goalLevels.goalLevels.map((item: any, index: number) => {
        return {
          goalLevelId: item._id,
          name: item.name,
          marks: {
            maximum:  "",
            minimum:  ""
          },
          scale: item.scale || 44,
          updatedType: '',
          isMaxError: false,
          isMinError: false
        }
      })
      if(nextProps.benchMarkInfo && nextProps.benchMarkInfo.benchmarks && nextProps.benchMarkInfo.benchmarks.length) {
        list = list.map((item: any) => {
          let index = nextProps.benchMarkInfo.benchmarks.findIndex((x: any) => x.goalLevel.name == item.name)
          if(index!=-1) {
            item.marks.minimum = nextProps.benchMarkInfo.benchmarks[index].marks.minimum
            item.marks.maximum = nextProps.benchMarkInfo.benchmarks[index].marks.maximum
          }
          return item
        })
      }
      list = list.sort((a: any, b: any) => b.scale - a.scale);
      let coupledGoalLevel = JSON.parse(JSON.stringify(list));
      if (
        nextProps.benchMarkInfo &&
        nextProps.benchMarkInfo.coupledTest &&
        nextProps.benchMarkInfo.benchmarks
      ) {
        let benchmarkLength = nextProps.benchMarkInfo.benchmarks.length;
        return {
          isLoaded: true,
          goalLevel: list,
          individualGoalLevel: list,
          coupledGoalLevel: coupledGoalLevel,
          originalGoalLevel: JSON.parse(JSON.stringify(list)),
          individualMaxMark: maxMarks,
          individualMinMark: minMarks === 0 ? minMarks : -minMarks,
          coupledMaxMark: nextProps.benchMarkInfo.benchmarks[0].marks.maximum,
          coupledMinMark: nextProps.benchMarkInfo.benchmarks[benchmarkLength - 1].marks.minimum,
          disableIndividualCheckbox: true,
          isCoupledTestAdded: true,
          benchmarkingType: 'Coupled',
          coupledTestContentId: nextProps.benchMarkInfo.coupledTest.contentId,
          coupledTestId: nextProps.benchMarkInfo.coupledTest.id,
          coupledTestDisplayName: nextProps.benchMarkInfo.coupledTest.name,
        };
      }
      else {
             for (let item of coupledGoalLevel) {
               item.marks.maximum = '';
               item.marks.minimum = '';
             }
            //  coupledGoalLevel[0].marks.maximum = list[0].marks.maximum;
            //  coupledGoalLevel[coupledGoalLevel.length - 1].marks.minimum = list[list.length - 1].marks.minimum;
             return {
               isLoaded: true,
               goalLevel: list,
               individualGoalLevel: list,
               coupledGoalLevel: coupledGoalLevel,
               originalGoalLevel: JSON.parse(JSON.stringify(coupledGoalLevel)),
               coupledMaxMark: maxMarks,
               coupledMinMark: minMarks === 0 ? minMarks : -minMarks,
               individualMaxMark: maxMarks,
               individualMinMark: minMarks === 0 ? minMarks : -minMarks,
             };
           }
    } else {
      return {
        isLoaded: true
      }
    }
  } else if(nextProps.content && nextProps.content.content) {
    if(nextProps.content.content.courseId && nextProps.content.content.courseId.length === 0) {
      return {
        isLoaded: true
      }
    }
    return null
  }
}

  componentDidUpdate(prevProps: any) {
    if(this.props.updateBenchMarkResponse !== prevProps.updateBenchMarkResponse) {
      if(this.props.updateBenchMarkResponse.statusCode == 200) {
        showMsg(this.props.updateBenchMarkResponse.message, 'success')
        const {content} = this.props
        this.props.fetchBenchMarkInfo({
          params: {type: 'test', typeId: content.content_Id}
        })
        this.props.onUpdateComplete()
      } else {
        this.props.onUpdateComplete()
        showMsg(this.props.updateBenchMarkResponse.message, 'error')
      }
      // this.setState({
      //   isOpenBenchmarkDialog: false
      // })
      
    }
  }

  // componentDidUpdate() {
  //   const {goalLevels} = this.props
  //   const {goalLevel} = this.state
    
    
  //   if(goalLevel.length != goalLevels.goalLevels.length) {
  //     this.setState({
  //       goalLevel: list
  //     })
  //   }
  // }

  handleDialogClose = () => {
    //add your code
    this.setState({
      isDiscardDialogOpen: true,
    })
  };
  onAddBenchmark() {
    if (this.props.isPostExpiryDays) {
      this.props.toggleLicenseExpiredDialog(true);
    } else {
     //add your code
    const { onUpdate, content } = this.props;
    const { goalLevel } = this.state;
    // const _cloneGoalLevel = () => goalLevel
    // const _clonedGoalLevel = _cloneGoalLevel()
    let list = goalLevel.filter((level: any) => level.marks.minimum !== '' && level.marks.maximum !== '').map((item: any) => {
      return {
        goalLevelId: item.goalLevelId,
        marks: item.marks
      }
    })
    // for(let item of _clonedGoalLevel) {
    //   delete item.isError
    //   delete item.name
    //   delete item.scale
    //   delete item.updatedType
    // }
  const objectToBeSent: any = {
    testId:  content.content_Id || content._id || getPropertyValue(content, 'content._id'),
    benchmarks: list
  }
  if (this.state.benchmarkingType == this.benchmarkTypes.COUPLED) {
    objectToBeSent['coupledId'] = this.state.coupledTestId;
  }
    onUpdate(objectToBeSent); 
    this.discardAllChanges()
    }
  }
  
  handleBenchmark() {
    //add your code
    const { onAdd } = this.props;
    // this.setState({
    //   isOpenBenchmarkDialog: true
    // });
    this.setState({
      goalLevel: []
    }, onAdd())
    
  }

  checkIfErrors(goalLevel: any, index: number, type: string) {
    const {goalLevel: goalLevels} = this.state
    let isRedundantOrGreater = 
    goalLevel.marks.minimum &&
    goalLevel.marks.maximum &&
    goalLevel.marks.minimum >= goalLevel.marks.maximum;
    let isNotEqualToOne = false
    if(type == 'maximum') {
      index--
      if(goalLevels[index] && 
        goalLevels[index].marks.minimum &&
        goalLevel.marks.maximum &&
        (goalLevel.marks.maximum - goalLevels[index].marks.minimum) !=1) {
        isNotEqualToOne = true
      }
    } else {
      index++
      if(goalLevels[index] && 
        goalLevels[index].marks.maximum &&
        goalLevel.marks.minimum &&
        (goalLevels[index].marks.maximum - goalLevel.marks.minimum) !=1) {
        isNotEqualToOne = true
      }
    }
    return isRedundantOrGreater || isNotEqualToOne;
  }

  handleUpdation(e: any, type: string, goal: any) {
    let { goalLevel, coupledMinMark, coupledMaxMark, individualMaxMark, individualMinMark } = this.state;
    let maxMarks = this.state.benchmarkingType === this.benchmarkTypes.COUPLED ? coupledMaxMark : individualMaxMark;
    let minMarks = this.state.benchmarkingType === this.benchmarkTypes.COUPLED ? coupledMinMark : individualMinMark;
    let goalId = goal.goalLevelId;
    const value: any = e.target.value !== "" ? parseInt(e.target.value) : '';
    const index = goalLevel.findIndex((goal: any) => goal.goalLevelId === goalId);

    const validateEachGoalLevel = () => {
        const firstFilledIndex = goalLevel.findIndex((level: any) => level.marks && (level.marks.minimum !== '' || level.marks.maximum !== ''));
        const lastFilledIndex = [...goalLevel].reverse().findIndex(level => level.marks && (level.marks.minimum !== '' || level.marks.maximum !== ''));
        const lastActualIndex = lastFilledIndex !== -1 ? goalLevel.length - 1 - lastFilledIndex : -1;

        goalLevel.forEach((level: any, i: number) => {
            const { minimum = '', maximum = '' } = level.marks || {};
            level.isMinError = false;
            level.isMaxError = false;

            // Skip validation if both minimum and maximum are empty
            if (!level.marks || (minimum === '' && maximum === '')) return;
            // Update type-specific conditions
            if (minimum !== '') {
                // Case 1: last filled index
                if (i === lastActualIndex) {
                    if (maximum !== '') {
                        if (minimum !== minMarks || minimum >= maximum) {
                            level.isMinError = true;
                        }
                    } else {
                        if (minimum !== minMarks) {
                            level.isMinError = true;
                        } else if (maximum === '') {
                            level.isMaxError = true;
                        }
                    }
                } else {
                    // Case 2: Inserted between levels
                    let nextMaxIndex = -1;
                    for (let j = i + 1; j < goalLevel.length; j++) {
                      if (goalLevel[j].marks && goalLevel[j].marks.maximum !== '') {
                        nextMaxIndex = j;
                        break;
                      }
                    }
                    const nextMax = nextMaxIndex !== -1 ? goalLevel[nextMaxIndex].marks.maximum : '';
                    if (maximum !== '') {
                        if ((nextMax && minimum !== nextMax + 1) || minimum >= maximum) {
                            level.isMinError = true;
                        }
                    } else {
                        if (nextMax && minimum !== nextMax + 1) {
                            level.isMinError = true
                        } else if (maximum === '') level.isMaxError = true;
                    }
                }
            }

            if (maximum !== '') {
                // Case 1: First entry
                if (i === firstFilledIndex) {
                    if (minimum !== '' && (maximum !== maxMarks || maximum <= minimum)) {
                        level.isMaxError = true;
                    } else {
                      if (maximum !== maxMarks) {
                        level.isMaxError = true;
                      } else if (minimum === '') {
                        level.isMinError = true;
                      }
                    }
                } else {
                    // Case 2: Last index
                    let lastPrevIndex = -1;
                    for (let j = i - 1; j >= 0; j--) { 
                      if (goalLevel[j].marks && goalLevel[j].marks.minimum !== '') {
                        lastPrevIndex = j;
                        break;
                      }
                    } 
                    const prevMin = lastPrevIndex !== -1 ? goalLevel[lastPrevIndex].marks.minimum : '';
                    if (minimum !== '') {
                        if ((prevMin && maximum !== prevMin - 1) || maximum <= minimum) {
                            level.isMaxError = true;
                        }
                    } else {
                        if (prevMin && maximum !== prevMin - 1) {
                          level.isMaxError = true;
                        } else if (minimum === '') {
                          level.isMinError = true;
                        }
                    }
                } 
            }
        });
    };

    if (index !== -1) {
        if (value === '' || (value <= maxMarks && value >= minMarks)) {
            goalLevel[index].marks[type] = value;
            goalLevel[index].isMaxError = false;
            goalLevel[index].isMinError = false;
        }

        validateEachGoalLevel();
    }

    this.setState({
        goalLevel: goalLevel
    });
}

  renderBenchMarkInfo() {
    const { benchMarkInfo } = this.props;
    // benchMarkInfo.benchmarks = benchMarkInfo.benchmarks &&
    //   benchMarkInfo.benchmarks.sort((a:any, b: any) => b.goalLevel.scale-a.goalLevel.scale)
    const { classes } = this.props;
    return (
      benchMarkInfo.benchmarks &&
      benchMarkInfo.benchmarks.map((item: any) => (
        <tr>
          <td className={classes.truncateTxt1}>{item.goalLevel.name}</td>
          <td>{item.marks.minimum}</td>
          <td>{item.marks.maximum}</td>
        </tr>
      ))
    );
  }

  sortGoalLevels(list: any = []) {
    if (list) return list.sort((a: any, b: any) => b.scale - a.scale);
    return [];
  }

  renderGoalLevels() {
    const { classes } = this.props;
    const { goalLevel} = this.state;
    return goalLevel.map((item: any, index: number) => (
      <tr key={item.goalLevelId}>
        <td className={classes.truncateTxt}>{item.name}</td>
        <td className={classes.posRel}>

          {/* TODO: uncomment later */}
         {/*  { index == goalLevel.length-1 ? (
             <TextField
             variant="outlined"
             disabled={true}
             classes={{ root: classes.graceTextField }}
             type="number"
             value={minMarks}
             onChange={e => this.handleUpdation(e, "minimum", item)}
           />
          ) : (
            <TextField
            variant="outlined"
            classes={{ root: classes.graceTextField }}
            type="number"
            value={item.marks.minimum}
            onChange={e => this.handleUpdation(e, "minimum", item)}
          />
          ) } */}
         
         <TextField
            variant="outlined"
            disabled={(this.state.benchmarkingType === this.benchmarkTypes.COUPLED && !this.state.isCoupledTestAdded)}
            classes={{ root: classes.graceTextField }}
            type="number"
            value={item.marks.minimum}
            onChange={e => this.handleUpdation(e, "minimum", item)}
          />
          {item.isMinError ? (
            <span className={classes.errorTxt}>Improper score range</span>
          ) : (
            ""
          )}
        </td> 
        <td className={classes.posRel}>
          {/* TODO: uncomment later */}
        {/* { index == 0 ? (
             <TextField
             variant="outlined"
             disabled={true}
             classes={{ root: classes.graceTextField }}
             type="number"
             value={maxMarks}
             onChange={e => this.handleUpdation(e, "maximum", item)}
           />
            ) : (
              <TextField
              variant="outlined"
              classes={{ root: classes.graceTextField }}
              value={item.marks.maximum}
              type="number"
              onChange={e => this.handleUpdation(e, "maximum", item)}
            />
            ) } */}

          <TextField
              variant="outlined"
              disabled={(this.state.benchmarkingType === this.benchmarkTypes.COUPLED && !this.state.isCoupledTestAdded)}
              classes={{ root: classes.graceTextField }}
              value={item.marks.maximum}
              type="number"
              onChange={e => this.handleUpdation(e, "maximum", item)}
            />
         
          {item.isMaxError ? (
            <span className={classes.errorTxt}>Improper score range</span>
          ) : (
            ""
          )}
        </td>
      </tr>
    ));
  }

  checkIfDisabled = () => {
    const {goalLevel} = this.state;
    let emptyGoalLevelCount = 0;
    for(let item of goalLevel) {
      if (item.marks.minimum === '' || item.marks.maximum === '') {
        emptyGoalLevelCount++;
      }
      if(item.isMaxError || item.isMinError || emptyGoalLevelCount === goalLevel.length) return true
    }
  }

  debouncedSearch = debounce((query: string) => {
    const performSearch = () => {
      try {
        getCoupledTestList(query, this.props.content.content._id).then(
          (res: any) => {
            if (query === this.state.coupledInputValue) {
              this.setState({
                testSearchLoader: false,
                suggestionBoxData: res.responseObject.tests,
              });
              if (this.state.isCoupledInputFocused) {
                this.setState({
                  showSuggestionBox: true,
                });
              }
            }
          }
        );
      } catch (error) {
        console.error('Error performing search:', error);
      }
    };
    if (query && query.length >= this.minSearchCharactersLength) {
      performSearch();
      this.setState({
        testSearchLoader: true,
      });
    }
  }, 1000);

  handleCoupledInputFocus = () => {
    this.setState({
      isCoupledInputFocused: true,
    });
  };
  handleCoupledInputBlur = () => {
    this.setState({
      showSuggestionBox: false,
      isCoupledInputFocused: false,
    });
  };
  handleCoupledInputChange = (event: any) => {
    const newSearchTerm = event.target.value;
    this.setState({
      coupledInputValue: newSearchTerm,
      showSuggestionBox: false,
      testSearchLoader: false,
    });
    if(!newSearchTerm.length){
      this.removeCoupleTest();
    }
    this.debouncedSearch(newSearchTerm);
  };

  removeCoupleTest = () => {
    this.setState({
      coupledTestContent: {},
      coupledTestContentId: '',
      coupledTestId: '',
      coupledTestDisplayName: '',
      isCoupledTestAdded: false,
      goalLevel: JSON.parse(JSON.stringify(this.state.originalGoalLevel)),
      coupledGoalLevel: JSON.parse(JSON.stringify(this.state.originalGoalLevel))
    });
  }

  handleCoupledTestSelect = (content: any) => {
    contentService.details(content.id + 'testpapers').then((res) => {
      // try{
      let { individualMaxMark, individualMinMark, goalLevel } = this.state;
      let maxMarks = individualMaxMark;
      let minMarks = individualMinMark;
      if (minMarks < 0) {
        minMarks = -minMarks;
      }
      let content = _.get(res, 'content');
      let data = _.get(res, 'content.data');
      let sections = _.get(res, 'content.data.sections');
      if (content && data && sections.length) {
        sections.map((section: any) => {
          section.subSection.map((item: any) => {
            let questionCountMultiplier =
              item.mandatoryQuestionCount || item.noOfQuestions || 0;
            minMarks = minMarks + item.negativeMarks * questionCountMultiplier;
            maxMarks = maxMarks + item.positiveMarks * questionCountMultiplier;
          });
        });
      }
      for (let item of goalLevel) {
        item.marks.maximum = '';
        item.marks.minimum = '';
      }
      // goalLevel[0].marks.maximum = maxMarks;
      // goalLevel[goalLevel.length - 1].marks.minimum =
      //   minMarks === 0 ? 0 : -minMarks;
      this.setState({
        coupledInputValue: content.contentId,
        coupledMaxMark: maxMarks,
        coupledMinMark: minMarks === 0 ? 0 : -minMarks,
        goalLevel: goalLevel,
        coupledGoalLevel: goalLevel,
        coupledTestContent: res,
        coupledTestContentId: res.content.contentId,
        coupledTestId: res.content._id,
        coupledTestDisplayName: res.content.displayName,
        isCoupledTestAdded: true,
      });
    });
  };
  cancelDiscard = (event: any) => {
    this.setState({
      isDiscardDialogOpen: false,
    });
  };
  discardAllChanges = () => {
    this.setState(
      {
        goalLevel: [],
        isDiscardDialogOpen: false,
        individualGoalLevel: [],
        coupledGoalLevel: [],
        coupledInputValue: '',
        suggestionBoxData: [],
        showSuggestionBox: false,
        testSearchLoader: false,
        coupledTestContent: {},
        coupledTestContentId: '',
        coupledTestId: '',
        coupledTestDisplayName: '',
        isCoupledTestAdded: false,
        benchmarkingType: this.benchmarkTypes.INDIVIDUAL,
      },
      () => {
        this.props.onClose();
      }
    );
  };

  render() {
    const { classes, benchMarkInfo, content, isOpen, from, goalLevels, addBenchmarkFromTest } = this.props;
    const isInUpdateState = benchMarkInfo.hasBenchmarks || from === 'testEdit'
    let updationText = isInUpdateState ? "Update Benchmark" : 'Add Benchmark'
    const {
      goalLevel,
      isLoaded,
      testSearchLoader,
      showSuggestionBox,
      coupledInputValue,
      suggestionBoxData,
      individualGoalLevel,
      coupledGoalLevel,
      coupledTestContentId,
      coupledTestDisplayName,
      isCoupledTestAdded,
      isDiscardDialogOpen,
      disableIndividualCheckbox,
      coupledMaxMark,
      coupledMinMark,
      individualMaxMark,
      individualMinMark
    } = this.state;
    let testContentId = content.content.contentId;
    let testDisplayName = content.content.displayName;
    let totalTestNamecharacters =
      (testContentId || '').length +
      (testDisplayName || '').length +
      (coupledTestContentId || '').length +
      (coupledTestDisplayName || '').length;
    let maxMarks = this.state.benchmarkingType === this.benchmarkTypes.COUPLED ? coupledMaxMark : individualMaxMark;
    let minMarks = this.state.benchmarkingType === this.benchmarkTypes.COUPLED ? coupledMinMark : individualMinMark;
    return (
      <>
      {
        isLoaded && (
            // goalLevel.length ? (
              from !== 'testEdit' && (
                <div>
                {/* @fronted add condition here for overlay card */}
                {goalLevel.length === 0 && (
                <Grid container direction="row" justify="center" alignItems="center" className={classes.overlayCard}>
                  <Grid item className={classes.overlayContent}>                  
                      <div className={classes.overlayImg}>
                        <img src="/assets/svg/myLibrary/goal_level.svg" />
                      </div>
                      <Typography className={classes.overlayTxt}>
                        Goal Level needs to be defined under the selected goal for adding the benchmarking 
                      </Typography>
                    </Grid>
                </Grid>
                )}
                {/* End overlay card */}
                <Grid container direction="row" justify="center" alignItems="center">
                  {!benchMarkInfo.hasBenchmarks ? (
                    <Grid item>                  
                      <div className={classes.imgCenter}>
                        <img src="/assets/svg/myLibrary/no-benchmark.svg" />
                      </div>
                      <Typography className={classes.headingtxt}>
                        No Benchmarks added!
                      </Typography>
                    </Grid>
                  ) : (
                    <div className={classes.tableStr}>
                      <Typography className={classes.tableHeading}>
                        {content.content.courseId &&
                          content.content.courseId[0] &&
                          content.content.courseId[0].courseType &&
                          content.content.courseId[0].courseType.name}
                      </Typography>
                      <Table className={classes.publishedBenchmark}>
                        <TableHead>
                          <tr>
                            <td>Goal Level</td>
                            <td>Min Marks</td>
                            <td>Max Marks</td>
                          </tr>
                        </TableHead>
                        <TableBody classes={{root:classes.autoScoroll}}>
                            <PerfectScrollbar className={classes.perfectScrollbar}>
                              {this.renderBenchMarkInfo()}
                            </PerfectScrollbar>
                      </TableBody>
                      </Table>
                    </div>
                  )}  
                </Grid>
                <div>
                  <Button
                    className={classes.benchmarkButton}
                    disabled={!content.content.ruleId}
                    autoFocus
                    variant="outlined"
                    color="primary"
                    onClick={this.handleBenchmark}
                  >
                  {benchMarkInfo.hasBenchmarks ? 'Edit' : 'Add Benchmark' }
                  </Button> 
                </div>
              </div>
              )
            // ) : (
            //   <div>
            //     <h1>no goals defined</h1>
            //   </div>
            // )
        )
      }
     
      
        <MyPATDialog
          dialogOpen={isOpen}
          dialogHasActions={true}
          dialogHeading={updationText}
          isAlignCenter={true}
          classes={{root: (isDiscardDialogOpen)? classes.discardContentOpacity: classes.dialogMain}}
          // onDialogClose={this.props.addToQueueCancel}
          customButtonVariant="withoutBorderCloseIcon"
          onDialogClose={this.handleDialogClose.bind(this)}
          isCustomBackground={false}
          isborderDialogAction={true}
          otherDialogProps={{
            fullWidth: true,
          }}
        >
          {addBenchmarkFromTest &&
            <div className={classes.addBenchMarkStrip}>
              Test Benchmark is mandatory to proceed. Please enter the Benchmark to publish the test
            </div>
          }
          <Grid container className={cx({[classes.marginTopStyle]: addBenchmarkFromTest})} direction="row" justify="center" alignItems="center">
            <div className={classes.benchmarkTable}>
            <PerfectScrollbar className={classes.perfectScrollBar}>
            <div className={classes.benchmarkingParentCont}>
                  {<div className={classes.benchmarkingType}>
                    <span className={classes.benchmarkingHeading}>
                      <b>Benchmarking Type:</b>
                    </span>
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        value={this.state.benchmarkingType}
                        onChange={(event, value) => {
                          this.setState({
                            benchmarkingType: value,
                            goalLevel:
                              value === this.benchmarkTypes.INDIVIDUAL
                                ? individualGoalLevel
                                : coupledGoalLevel,
                          });
                        }}
                        row
                        name="benchmark-type-button"
                      >
                        <FormControlLabel
                          value={this.benchmarkTypes.INDIVIDUAL}
                          control={<Radio color="primary" />}
                          label={this.benchmarkTypes.INDIVIDUAL}
                          disabled={disableIndividualCheckbox}
                        />
                        <FormControlLabel
                          value={this.benchmarkTypes.COUPLED}
                          control={<Radio color="primary" />}
                          label={this.benchmarkTypes.COUPLED}
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>}
                  {this.state.benchmarkingType === this.benchmarkTypes.COUPLED && !disableIndividualCheckbox && (
                    <>
                      <div className={classes.testIds}>
                        <div className={classes.testInputCont}>
                          <div className={classes.testInputTitle}>
                            Test ID
                          </div>
                          <input
                            className={classes.testInput}
                            type="text"
                            value={this.props.content.contentId || this.props.content.content.contentId}
                            disabled
                          />
                        </div>
                        <div className={classes.testInputCont}>
                          <div className={classes.testInputTitle}>
                            Coupled Test ID
                          </div>
                          <div className={classes.coupledTestInput}>
                            <input
                              className={classes.testInput}
                              placeholder="Enter coupled Test Id"
                              type="text"
                              value={coupledInputValue}
                              onFocus={this.handleCoupledInputFocus}
                              onBlur={this.handleCoupledInputBlur}
                              onChange={this.handleCoupledInputChange}
                            />
                            {testSearchLoader && (
                              <CircularProgress
                                className={classes.circularProgress}
                                size={"25px"}
                              />
                            )}
                          </div>
                          {showSuggestionBox && (
                            <div className={classes.suggestionBox}>
                              <PerfectScrollbar className={classes.suggestionScrollbar}>
                                <div className={classes.suggestionItems}>
                                  {suggestionBoxData.length ? suggestionBoxData.map((value, index) => {
                                    return (
                                      <div
                                        key={index}
                                        className={classes.suggestionItem}
                                        onMouseDown={() =>
                                          this.handleCoupledTestSelect(value)
                                        }
                                      >
                                        {value.contentId + " " + "(" + value.name + ")"}
                                      </div>
                                    );
                                  })
                                  : <div className={classes.suggestionItem}>
                                      No Relevant Couple Test ID Found
                                    </div>
                                  }
                                </div>
                              </PerfectScrollbar>
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {(
                    <div className= {cx(classes.allTestDetails, {[classes.rowAlign]: totalTestNamecharacters>this.maxTestCharacterLength})}>
                      <p>
                      {testContentId}&nbsp;
                      <span>
                        ( {testDisplayName} ) 
                        {isCoupledTestAdded && this.state.benchmarkingType ===
                      this.benchmarkTypes.COUPLED &&  "," }
                      </span>
                      </p>
                      { isCoupledTestAdded &&
                       this.state.benchmarkingType ===
                      this.benchmarkTypes.COUPLED &&
                       <p>&nbsp;{coupledTestContentId}&nbsp;
                      <span>( {coupledTestDisplayName} )</span></p>
                      }
                    </div>
                  )}
                </div>

              {
               isLoaded && from == "testEdit" && goalLevel.length === 0 ? (
             <p>Goal Level are not defined for this goal, either define the goal level or change the goal
             Otherwise test cannot published until benchmarking is updated.</p>
               ) : (
                <Table className=  {cx({[classes.reduceTableOpacity]: !(this.state.benchmarkingType === this.benchmarkTypes.INDIVIDUAL || isCoupledTestAdded)})}>
                <TableHead>
                  <tr>
                    <td>Goal Level</td>
                    <td>Minimum Marks <br/> ({ minMarks })</td>
                    <td>Maximum Marks <br/> ({ maxMarks })</td>
                  </tr>
                </TableHead>
                <TableBody>{this.renderGoalLevels()}</TableBody>
              </Table>
               )
              }
             
              </PerfectScrollbar>
            </div>
          </Grid>
          <div className={classes.txtRight}>
            {/* @frontend : add condition for disable button (disabled class name) */}
            <Button
              disabled={this.checkIfDisabled() || goalLevel.length === 0}
              className={classNames({[classes.benchmarkAddBtn]: true, [classes.disabled]: this.checkIfDisabled()})}
              autoFocus
              variant="outlined"
              color="primary"
              onClick={this.onAddBenchmark}
            >
              {isInUpdateState ? "Update" : "Add"} Benchmarks {addBenchmarkFromTest ? "& Publish" : ''}
            </Button>
          </div>
          {isDiscardDialogOpen && (
            <div className={classes.discardDialog}>
              <div className={classes.discardDescriptionTest}>
                <div>
                  <b>Discard Benchmarking Changes</b>
                </div>
                Are you sure you wish to discard the updated changes? All
                current changes will be lost.
              </div>
              <div className={classes.discardAction}>
                <Button color="primary" onClick={this.discardAllChanges}>
                  Discard
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.cancelDiscard}
                >
                  Cancel
                </Button>
              </div>
            </div>
          )}
        </MyPATDialog>
      </>
    );

    // {isOpenBenchmarkDialog && this.handleBenchmark()}
  }
}

const mapStateToProps = (state: any) => ({
  benchMarkInfo: _.get(state, "mylibraryData.content.benchMarkInfo", {}),
  goalLevels: _.get(state, "mylibraryData.content.goalLevels", {}),
  updateBenchMarkResponse: _.get(state, "mylibraryData.content.updateBenchMarkResponse", {}),
  showLicenseExpiredDialog:  state.loginData.userData &&  state.loginData.userData.showLicenseExpiredDialog,
  isPostExpiryDays:  state.loginData.userData &&  state.loginData.userData.isPostExpiryDays
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
  {
    showMsg,
    fetchBenchMarkInfo: contentActions.fetchBenchMarkInfo,
    toggleLicenseExpiredDialog,
    setLoggedInUser
  },
  dispatch
);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Benchmark));
